import { Button, Modal } from "@ttc3k/trekker";
import { Flex } from "styled-system/jsx";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

type CustomResourceIframeModalProps = {
  open: boolean;
  onClose: () => void;
  iframeUrl: string;
};

export const CustomResourceIframeModal = ({
  open,
  onClose,
  iframeUrl,
}: CustomResourceIframeModalProps) => {
  const { t } = useTranslation("home", {
    keyPrefix: "VIEWS.BROADCAST.VIEW_MODAL",
  });

  useEffect(() => {
    if (!open) {
      return;
    }

    const handleMessage = (event: MessageEvent) => {
      if (!event.data || event.data.type !== "DOWNLOAD_CSV") {
        return;
      }

      const { fileName, csvContent, mimeType } = event.data;
      if (!fileName || !csvContent) {
        return;
      }

      const blob = new Blob([csvContent], { type: mimeType || "text/csv" });
      const url = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(url);
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [open]);

  return (
    <Modal
      open={open}
      onOpenChange={onClose}
      placement={"centerPane"}
      closeTriggerVisual={"light"}
      hideCloseTrigger
      noMaxH
      portal
    >
      <Flex
        width={"calc(100vw - 64px)"}
        height={"calc(100vh - 64px)"}
        borderRadius={"200"}
        overflow={"hidden"}
        bg={"white"}
      >
        <Flex flexDir={"column"} width={"full"} height={"full"}>
          <Flex
            alignItems={"center"}
            justifyContent={"flex-end"}
            gap={"150"}
            width={"full"}
            py={"200"}
            px={"200"}
            bg={"bg.wa.light"}
          >
            <Button
              as={"a"}
              href={iframeUrl}
              target="_blank"
              rel="noopener noreferrer"
              mode={"light"}
            >
              {t("OPEN_IN_NEW_TAB")}
            </Button>
            <Button mode={"light"} onClick={onClose} type="button">
              {t("CLOSE")}
            </Button>
          </Flex>
          <iframe
            src={iframeUrl}
            style={{ width: "100%", height: "100%", border: 0 }}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen; download"
            referrerPolicy="no-referrer"
            loading="eager"
          />
        </Flex>
      </Flex>
    </Modal>
  );
};
